export const AI_BUSINESS_ANALYTICS_CHUNK = '/ai-business-analytics';
